module.exports = __webpack_public_path__ + "static/media/bei2.06f69895.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_136/imgs/bei2.png
// module id = 429
// module chunks = 0